import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5490894e")

_pushScopeId("data-v-5490894e")
const _hoisted_1 = { class: "menu-content" }
const _hoisted_2 = { class: "text" }
const _hoisted_3 = {
  key: 0,
  class: "sub-text"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_menu_content = _resolveComponent("menu-content", true)

  return (_openBlock(), _createBlock("ul", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.menus, (menu, index) => {
      return (_openBlock(), _createBlock(_Fragment, {
        key: menu.text || index
      }, [
        (!menu.hide)
          ? (_openBlock(), _createBlock("li", {
              key: 0,
              class: ["menu-item", {'divider': menu.divider, 'disable': menu.disable}],
              onClick: _withModifiers(($event: any) => (_ctx.handleClickMenuItem(menu)), ["stop"])
            }, [
              (!menu.divider)
                ? (_openBlock(), _createBlock("div", {
                    key: 0,
                    class: ["menu-item-content", {
            'has-children': menu.children,
            'has-handler': menu.handler,
          }]
                  }, [
                    _createVNode("span", _hoisted_2, _toDisplayString(menu.text), 1),
                    (menu.subText && !menu.children)
                      ? (_openBlock(), _createBlock("span", _hoisted_3, _toDisplayString(menu.subText), 1))
                      : _createCommentVNode("", true),
                    (menu.children && menu.children.length)
                      ? (_openBlock(), _createBlock(_component_menu_content, {
                          key: 1,
                          class: "sub-menu",
                          menus: menu.children,
                          handleClickMenuItem: _ctx.handleClickMenuItem
                        }, null, 8, ["menus", "handleClickMenuItem"]))
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true)
            ], 10, ["onClick"]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
})